import React from 'react'
import { Link } from 'react-router-dom'
export const ProductSolution = (props) => {
   return (<div className='product-solution max-width-box'>
                <div className='ps-title'>
                    <h3>产品解决方案</h3>
                    <div><span className='line'></span></div>
                </div>
                <p className='ps-content'>新集运系列产品是为助力内贸集运行业转型升级研发的移动互联网产品，通过云计算、大数据、智能交通等最新技术，为集运行业提供全方位“互联网+”解决方案；帮助货代、拖车打造一个高效、低成本、风险可控、提供高品质服务的更具核心竞争力的企业。</p>
                <div className='ps-types'>
                    <div className='ps-item' >
                    <div className='item-inner'>
                        <Link to=''>
                        <div>
                            <img src={props.ptype1} alt='货代拖车系统' width='147' height='89'/>
                        </div>
                        <h3>货代拖车系统</h3>
                        </Link>
                        <p >“一站式”全业务流程管理上下游数据智能交互，精准高效</p>
                        </div>
                    </div>
                    <div className='ps-item' >
                    <div className='item-inner'>
                    <Link to=''>
                        <div>
                            <img src={props.ptype2} alt='货运交易平台'  width='147' height='89'/>
                        </div>
                        <h3>货运交易平台</h3>
                        </Link>
                        <p>货运交易平台搭载手机APP实现车与货精准匹配</p>
                        </div>
                    </div>
                    <div className='ps-item' >
                    <div className='item-inner'>
                    <Link to=''>
                        <div>
                            <img src={props.ptype3} alt='信用评价体系'  width='147' height='89'/>
                        </div>
                        <h3>信用评价体系</h3>
                        </Link>
                        <p>构建内贸集运行业权威的信用评价体系为每个角色建立信用评级</p>
                        </div>
                    </div>
                    <div className='ps-item' >
                    <div className='item-inner'>
                    <Link to=''>
                        <div>
                            <img src={props.ptype4} alt='物流行业APP'  width='147' height='89'/>
                        </div>
                        <h3>物流行业APP</h3>
                        </Link>
                        <p>为不同角色制定手机APP随时随地移动办公</p>
                        </div>
                    </div>
                </div>
            </div>
         )
}



// WEBPACK FOOTER //
// ./src/components/productSolution/index.js